import React from 'react';

export interface IAuthenticationFailureProps {
    message: string;
}

export function AuthenticationFailure(props: IAuthenticationFailureProps) {

    return (
        <>
            <div style={{
                width: '100%',
                backgroundColor: '#e34f5c',
                padding: '20px',
                paddingLeft: '30px',
                marginBottom: '0px',
                color: 'white',
                marginTop: '20px',
                textAlign: 'left',
            }}>
                {props.message}
            </div>
        </>
    );

}